import React from 'react';

import PropTypes from 'prop-types';

import theme, { StylableComponent } from '@adsk/alloy-react-theme';

type Props = StylableComponent<HTMLDivElement> & {
  disableBorder?: boolean;
};

const Header = ({
  style,
  className,
  children,
  disableBorder,
  ...props
}: Props) => (
  <div
    {...props}
    className={className}
    css={[
      theme.typography.heading1,
      {
        display: 'flex',
        alignItems: 'flex-start',
        justifyContent: 'space-between',
        color: theme.tokens.colors.text.primary.value,
        position: 'relative',
        minHeight: 70,
        borderBottom: !disableBorder
          ? `1px solid ${theme.tokens.colors.border.subtle.value}`
          : '',
        padding: `20px ${theme.spacing.L}px`,
        wordBreak: 'break-word',
      },
      style,
    ]}
  >
    {children}
  </div>
);

Header.propTypes = {
  /** The content of modal */
  children: PropTypes.any,
  /** Styles applied to the root element */
  style: PropTypes.oneOfType([PropTypes.object, PropTypes.array]),
  /** Class applied to the root element */
  className: PropTypes.string,
  /** disable border bottom */
  disableBorder: PropTypes.bool,
};

export default Header;
